
import { toast } from "sonner";
import { CampaignFormValues } from "../types/formTypes";
import { ModalCampaignQuestionFormData } from "@/types/modalCampaigns";
import { createCampaign, updateCampaign } from "@/services/modalCampaigns";
import { User } from "@/context/AuthContext";

export const handleFormSubmission = async (
  values: CampaignFormValues,
  questions: ModalCampaignQuestionFormData[],
  currentUser: User | null,
  existingCampaign: { id: string } | null,
  onSuccess: () => void,
  setIsSubmitting: (value: boolean) => void
): Promise<void> => {
  try {
    setIsSubmitting(true);

    if (existingCampaign) {
      // Update existing campaign
      await updateCampaign(existingCampaign.id, {
        title: values.title,
        content: values.content,
        start_date: values.start_date,
        end_date: values.end_date,
        frequency: values.frequency,
        users: values.users,
        has_quiz: values.has_quiz,
        min_score: values.min_score,
        max_attempts: values.max_attempts,
        repeat_on_failure: values.repeat_on_failure,
        allow_dismiss: values.allow_dismiss,
        questions: questions
      });
      toast.success('Campagne bijgewerkt');
    } else {
      // Create new campaign
      if (!currentUser) {
        toast.error('Je moet ingelogd zijn om een campagne aan te maken');
        return;
      }
      
      await createCampaign(
        {
          title: values.title,
          content: values.content,
          start_date: values.start_date,
          end_date: values.end_date,
          frequency: values.frequency,
          users: values.users,
          has_quiz: values.has_quiz,
          min_score: values.min_score,
          max_attempts: values.max_attempts,
          repeat_on_failure: values.repeat_on_failure,
          allow_dismiss: values.allow_dismiss,
          questions: questions
        },
        currentUser.id
      );
      toast.success('Nieuwe campagne aangemaakt');
    }

    onSuccess();
  } catch (error) {
    console.error('Error saving campaign:', error);
    toast.error('Fout bij het opslaan van de campagne');
  } finally {
    setIsSubmitting(false);
  }
};
